module.exports = __webpack_public_path__ + "img/home-blue.d0eda0ab.svg";